// extracted by mini-css-extract-plugin
module.exports = {"topButtonContainer":"Version1020_topButtonContainer__3wQ8L"};